import { createSlice, configureStore, combineReducers } from '@reduxjs/toolkit'
import {
  RouterType,
  CollectionType,
  TokenType,
  BotConfigType,
  BatchConfigType,
  FrontrunBotConfigType
} from './type'
import { MainTokenConfig } from '@/config';
import providerReducer from './providerSlice';
const initialState = {
  chainId: 56,  // 公链
  router: { label: '', address: '' },  // 路由
  universalRouter: '', // universalRouter地址
  permit2: '', // permit2地址
  v3Factory: '', // v3Factory地址
  quoter: '', // quoter地址
  rpc: '',  // 网站链接

  token: {
    address: '',
    symbol: '',
    decimals: 0
  }, // 代币

  feeV3: '',

  spenToken: MainTokenConfig[56][0], // 使用的代币
  pairToken: {}, // 加池子的代币

  privatekeyArray: [], // 刷单钱包私钥
  autoTransFer: false,
  minTransactionValue: '0.01',
  batchConfig: {
    isBatch: false,
    number: ''
  } as BatchConfigType, // 批量操作

  mainConfig: {
    useWalletWay: 0,
    mode: 0,
    isBuyAmount: 0, // 买入计算方式 0金额 1数量
    isSellAmount: 0,
    startTime: 0
  },

  botConfig: {
    number: '',
    price: '',
    minPrice: '',
    maxPrice: '',
    buyPro: '',
    buyTypeMoney: false,
    minBuy: '',
    maxBuy: '',
    sellTypeMoney: false,
    minSell: '',
    maxSell: '',
    minTime: '0',
    maxTime: '0',

    isMaxHove: false,
    isStartTime: false,
    walletMaxHove: '',
    startTime: '',
  } as BotConfigType,

  collection: {
    token: '', // 归集的代币
    to: '' // 归集地址
  },
  targetIndex: 0, // 0 目标拉升 1 代币卖出
  gaoPaoIndex: 0,// 0 高抛 1 低吸
  isErrorNetwork: false,

  senderTokenConfig: [], // 发送地址数组
  senderToken: {// 发送token
    address: '',
    symbol: '',
    decimals: ''
  },
  accountIsMumber: false,
  frontrunBotConfig: {
    isAntikill: 0,
    minPool: '',
    privateKey: '',
    tokenAddr: '',
    pairType: '',
    spenedToken: '',
    buyAmount: '',
    gasPrice: '',
    gasLimit: '1000000',
    startTime: 0,
    aheadTime: '',
    reqInvite: '',
    reqNumber: '',
    isAutoSell: 0,
    priceRise: '',
    sellRatio: ''
  },
  isSigner: false,

  isSlippage: true,
  slippage: '1',
  isShowGas: false,
  isAdvanced: false,
  gas: '',
  currentGas: '',
  gasLimit: '',
  vip: false,
  pool: { WETHToken: '', price: "", pairAddress: '' },
  v4PriceConfig: {},
  swapType: "",
}

export const counterSlice = createSlice({
  name: 'bot',
  initialState,
  reducers: {

    swapTypeChange(state, action) {
      state.swapType = action.payload
    },
   
    v4PriceConfigChange(state, action) {
      state.v4PriceConfig = action.payload
    },
    chainIdChange(state, action) {
      state.chainId = action.payload
    },
    routerChange(state, action) {
      state.router = action.payload
    },
    universalRouterChange(state, action) {
      state.universalRouter = action.payload
    },
    permit2Change(state, action) {
      state.permit2 = action.payload
    },
    v3FactoryChange(state, action) {
      state.v3Factory = action.payload
    },
    quoterChange(state, action) {
      state.quoter = action.payload
    },
    rpcChange(state, action) {
      state.rpc = action.payload
    },
    tokenChange(state, action) {
      state.token = action.payload
    },
    feeV3Change(state, action) {
      state.feeV3 = action.payload
    },
    spenTokenChange(state, action) {
      state.spenToken = action.payload
    },
    pairTokenChange(state, action) {
      state.pairToken = action.payload
    },
    minTransactionValueChange(state, action) {
      state.minTransactionValue = action.payload
    },
    frontrunBotConfigChanged(state, action) {
      state.frontrunBotConfig = action.payload
    },

    privatekeyArrayChange(state, action) {
      state.privatekeyArray = action.payload
    },
    mainConfigChange(state, action) {
      state.mainConfig = action.payload
    },
    botConfigChange(state, action) {
      state.botConfig = action.payload
    },
    batchConfigChange(state, action) {
      state.batchConfig = action.payload
    },


    collectionChange(state, action) {
      state.collection = action.payload
    },

    targetIndexChange(state, action) {
      state.targetIndex = action.payload
    },
    isErrorNetworkChange(state, action) {
      state.isErrorNetwork = action.payload
    },
    senderTokenConfigChange(state, action) {
      state.senderTokenConfig = action.payload
    },
    senderTokenChange(state, action) {
      state.senderToken = action.payload
    },
    accountIsMumberChange(state, action) {
      state.accountIsMumber = action.payload
    },
    gaoPaoIndexChange(state, action) {
      state.gaoPaoIndex = action.payload
    },

    autoTransFerChange(state, action) {
      state.autoTransFer = action.payload
    },
    isSignerChange(state, action) {
      state.isSigner = action.payload
    },
    isSlippageChange(state, action) {
      state.isSlippage = action.payload
    },
    slippageChange(state, action) {
      state.slippage = action.payload
    },
    isShowGasChange(state, action) {
      state.isShowGas = action.payload
    },
    isAdvancedChange(state, action) {
      state.isAdvanced = action.payload
    },
    gasChange(state, action) {
      state.gas = action.payload
    },
    currentGasChange(state, action) {
      state.currentGas = action.payload
    },
    gasLimitChange(state, action) {
      state.gasLimit = action.payload
    },
    vipChange(state, action) {
      state.vip = action.payload
    },
    poolChange(state, action) {
      state.pool = action.payload
    },
  },
});

export const {
  chainIdChange,
  routerChange,
  universalRouterChange,
  permit2Change,
  v3FactoryChange,
  quoterChange,
  rpcChange,
  tokenChange,
  feeV3Change,
  spenTokenChange,
  pairTokenChange,
  minTransactionValueChange,
  batchConfigChange,
  privatekeyArrayChange,
  botConfigChange,
  mainConfigChange,
  autoTransFerChange,
  collectionChange,
  targetIndexChange,
  isErrorNetworkChange,
  senderTokenConfigChange,
  senderTokenChange,
  accountIsMumberChange,
  gaoPaoIndexChange,
  frontrunBotConfigChanged,
  isSignerChange,
  isSlippageChange,
  slippageChange,
  isShowGasChange,
  gasChange,
  gasLimitChange,
  isAdvancedChange,
  currentGasChange,
  vipChange,
  poolChange,
  v4PriceConfigChange,
  swapTypeChange
} = counterSlice.actions

// 修改所有 selectors，添加 state.bot
export const v4PriceConfig = (state: RootState) => state.bot.v4PriceConfig
export const chainId = (state: RootState) => state.bot.chainId
export const swapType = (state: RootState) => state.bot.swapType
export const router = (state: RootState) => state.bot.router
export const universalRouter = (state: RootState) => state.bot.universalRouter
export const permit2 = (state: RootState) => state.bot.permit2
export const v3Factory = (state: RootState) => state.bot.v3Factory
export const quoter = (state: RootState) => state.bot.quoter
export const rpc = (state: RootState): string => state.bot.rpc
export const token = (state: RootState) => state.bot.token
export const feeV3 = (state: RootState): string => state.bot.feeV3
export const spenToken = (state: RootState) => state.bot.spenToken
export const pairToken = (state: RootState) => state.bot.pairToken
export const privatekeyArray = (state: RootState) => state.bot.privatekeyArray
export const batchConfig = (state: RootState) => state.bot.batchConfig
export const frontrunBotConfig = (state: RootState) => state.bot.frontrunBotConfig
export const botConfig = (state: RootState) => state.bot.botConfig
export const mainConfig = (state: RootState) => state.bot.mainConfig  // ← 这里修改
export const collection = (state: RootState): CollectionType => state.bot.collection
export const targetIndex = (state: RootState): number => state.bot.targetIndex
export const isErrorNetwork = (state: RootState): boolean => state.bot.isErrorNetwork
export const senderTokenConfig = (state: RootState) => state.bot.senderTokenConfig
export const senderToken = (state: RootState) => state.bot.senderToken
export const accountIsMumber = (state: RootState) => state.bot.accountIsMumber
export const gaoPaoIndex = (state: RootState) => state.bot.gaoPaoIndex
export const autoTransFer = (state: RootState) => state.bot.autoTransFer
export const minTransactionValue = (state: RootState) => state.bot.minTransactionValue
export const isSigner = (state: RootState) => state.bot.isSigner
export const isSlippage = (state: RootState) => state.bot.isSlippage
export const slippage = (state: RootState) => state.bot.slippage
export const isShowGas = (state: RootState) => state.bot.isShowGas
export const isAdvanced = (state: RootState) => state.bot.isAdvanced
export const gas = (state: RootState) => state.bot.gas
export const currentGas = (state: RootState) => state.bot.currentGas
export const gasLimit = (state: RootState) => state.bot.gasLimit
// export const WETHToken = (state: RootState) => state.bot.WETHToken
export const vip = (state: RootState) => state.bot.vip
export const pool = (state: RootState) => state.bot.pool

// const persistConfig = {
//   key: "869bot",
//   storage: storage,
// };

// const myPersistReducer = persistReducer(persistConfig, counterSlice.reducer);

// const store = configureStore({
//   reducer: myPersistReducer,
//   middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
// });

// export const persistor = persistStore(store);
// export default store;

// export type RootState = ReturnType<typeof store.getState>
// export type AppDispatch = typeof store.dispatch

const rootReducer = combineReducers({
  bot: counterSlice.reducer,    
  provider: providerReducer,      
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;